export default{
    smartScreen:{
        smartScreenList:"web/screen/query/list",    //主放映区
        removeProgram:"web/screen/removeProgram",   //主放映区移除
        advertiseList:"web/advertise/query/list",   //广告区
        advertiseRemoveProgram:"web/advertise/removeProgram",//广告区移除
        queryOnCondition:"broadcastPlacard/queryOnCondition/",   //告示区列表
        removePlacard:"broadcastPlacard/remove/placard/",    //移除直播告示
        delAdvertise:"web/screen/delAdvertise", // 刪除主放映区未发布节目
        advertiseDelAdvertise:"web/advertise/delAdvertise",  //刪除未发布广告节目
        deleteCast:"broadcastPlacard/delete",   //删除公告
        saveandUpdate:"web/screen/saveandUpdate",   //主放映区下一步保存
        broadcastPlacardCreate:"broadcastPlacard/create",       //创建直播公告
        screenDetail:"web/screen/query/show/detail/",   // 放映区详情
        queryLog:"web/advertise/query/log/",    // 直播间日志
        queryOperationRecord:"broadcastPlacard/queryOperationRecord/",  //告示区日志
        broadcasterInfo:"/room/manage/query/broadcasterInfo",   //直播信息查询
        singleQuery:"broadcastPlacard/singleQuery/", //告示区详情
        broadcastPlacardUpdate:"/broadcastPlacard/update",  //修改直播间告示
        advertiseSave:"web/advertise/save",  //創建廣告
        broadcastAbout:"web/screen/query/broadcast/bout",   //直播场次
        forbidenroom:'/room/manage/pause/room',/* 封禁直播间 */
        unforbidenroom:'/room/manage/resume/room',/* 解禁直播间 */
        queryDetail:"web/advertise/query/detail/",  //广告区详情
        deviceList:"web/device/query/list",     //屏幕管理列表
        netRecord:"web/device/query/net/record",    //联网纪录列表
        queryDevice:"web/device/query/detail/",    //屏幕详情
        deviceStatus:"web/device/query/device/status",  //设备绑定
        queryOnAirNum:"room/manage/query/onAirNum",    //查询正在直播的房间数
        advertiseUpdate:"web/advertise/update", //广告区编辑
    }
}